import styled from 'styled-components';

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  @media screen and (max-width: 768px) {
    overflow-x: scroll;
  }
`;

export const StyledTable = styled.table<Props>`
  table-layout: fixed;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border: ${({ noBorder, theme }) =>
    !noBorder
      ? theme.title === 'dark' || theme.title === 'contrast'
        ? '1px solid' + theme.colors?.text.tertiary
        : '1px solid' + theme.colors?.gray03
      : 'none'};
  border-radius: 12px;
  background-color: ${({ theme }) =>
    theme.title === 'dark'
      ? theme.colors?.gray01
      : theme.colors?.gray01 || 'transparent'};
  overflow: hidden;

  tr td:last-child,
  tr th:last-child {
    border-right: none;
  }
  tr:last-child > td {
    border-bottom: none;
  }

  tr:first-child th:first-child {
    border-top-left-radius: 12px;
  }

  tr:first-child th:last-child {
    border-top-right-radius: 12px;
  }

  tr:last-child td:first-child {
    border-bottom-left-radius: 12px;
  }

  tr:last-child td:last-child {
    border-bottom-right-radius: 12px;
  }

  @media screen and (max-width: 768px) {
    min-width: 100%;
    width: max-content;
  }
`;

export const Tr = styled.tr``;

interface Props {
  first?: boolean;
  last?: boolean;
  noPadding?: boolean;
  noBorder?: boolean;
  align?: 'center' | 'left' | 'right' | 'justify' | 'char' | string;
}

export const StyledTh = styled.th<Props>`
  text-align: ${(props) => props.align};
  word-break: break-word;
  white-space: normal;
  padding: ${(props) => (!props.noPadding ? '1.5rem 2rem' : '0')};
  color: ${({ theme }) =>
    theme.title == 'dark'
      ? theme.colors?.text.tertiary
      : theme.colors?.text.secondary};
  background-color: ${({ theme }) =>
    theme.title === 'dark'
      ? theme.colors?.gray02
      : theme.colors?.gray02 || 'transparent'};
  border-bottom: ${({ noBorder, theme }) =>
    !noBorder
      ? theme.title === 'dark' || theme.title === 'contrast'
        ? '1px solid' + theme.colors?.text.tertiary
        : '1px solid' + theme.colors?.gray03
      : 'none'};
  border-right: ${({ noBorder, theme }) =>
    !noBorder
      ? theme.title === 'dark' || theme.title === 'contrast'
        ? '1px solid' + theme.colors?.text.tertiary
        : '1px solid' + theme.colors?.gray03
      : 'none'};

  @media screen and (max-width: 768px) {
    white-space: nowrap;
    word-break: normal;
  }
`;

export const StyledTd = styled.td<Props>`
  padding: ${(props) => (!props.noPadding ? '0.5rem 2rem' : '0')};
  word-break: break-word;
  overflow-wrap: break-word;
  word-wrap: break-word;
  white-space: normal;
  color: ${({ theme }) =>
    theme.title == 'dark'
      ? theme.colors?.text.tertiary
      : theme.colors?.text.secondary};
  border-bottom: ${({ noBorder, theme }) =>
    !noBorder
      ? theme.title === 'dark' || theme.title === 'contrast'
        ? '1px solid' + theme.colors?.text.tertiary
        : '1px solid' + theme.colors?.gray03
      : 'none'};
  border-right: ${({ noBorder, theme }) =>
    !noBorder
      ? theme.title === 'dark' || theme.title === 'contrast'
        ? '1px solid' + theme.colors?.text.tertiary
        : '1px solid' + theme.colors?.gray03
      : 'none'};

  @media screen and (max-width: 768px) {
    white-space: nowrap;
    word-break: normal;
  }
`;

export const H6 = styled.h6`
  font-weight: bold;
  color: ${({ theme }) =>
    theme.title == 'dark'
      ? theme.colors?.text.tertiary
      : theme.colors?.text.secondary};
`;

export const NotFound = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;
